import {
  Button,
  Card,
  Col,
  DatePicker,
  Input,
  InputNumber,
  message,
  notification,
  Row,
  Select,
  Table,
} from "antd";
import React from "react";
import { withRouter } from "react-router-dom";
import {
  baseUrl,
  payrollBranch,
  payrollCompany,
  payrollEmployee,
} from "../../constants/url";
import { axiosInstance } from "../../commons/commons";
import moment from "moment";

class EmployeeAttendance extends React.Component {
  state = {
    companyData: { list: [], selectedIndex: null, selectedValue: null },
    branchData: { list: [], selectedIndex: null, selectedValue: null },
    employeeData: { list: [], selectedIndex: null, selectedValue: null },
    attendanceTypesData: { list: [], selectedIndex: null, selectedValue: null },
    payrollSettingData: { REG_HRS: 8 },
    date: { selectedValue: moment() },
    tableData: { list: [] },
    postedStatus: { selectValue: "Not Posted" },
  };

  getInitialState = async () => {
    let state = {
      companyData: { list: [], selectedIndex: null, selectedValue: null },
      branchData: { list: [], selectedIndex: null, selectedValue: null },
      employeeData: { list: [], selectedIndex: null, selectedValue: null },
      payrollSettingData: { REG_HRS: 8 },
      attendanceTypesData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      date: { selectedValue: moment() },
      tableData: { list: [] },
      postedStatus: { selectValue: "Not Posted" },
    };
    await axiosInstance
      .get(payrollCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message.rows;
      })
      .catch(() => {});
    await axiosInstance
      .get(payrollCompany + "/attendanceTypes")
      .then((res) => {
        if (res.data.success) state.attendanceTypesData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(payrollCompany + "/payrollSettings")
      .then((res) => {
        if (res.data.success)
          state.payrollSettingData = res.data.message || { REG_HRS: 8 };
      })
      .catch(() => {});
    return state;
  };

  loadAttendance = async () => {
    if (!this.state.companyData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select a company !",
      });
    }
    if (!this.state.branchData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select a branch !",
      });
    }
    if (!this.state.employeeData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select an employee !",
      });
    }
    if (!this.state.date.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select date !",
      });
    }
    const CompanyID =
      this.state.companyData.list[this.state.companyData.selectedIndex]
        .Company_ID;
    const BranchID =
      this.state.branchData.list[this.state.branchData.selectedIndex].Branch_ID;
    const EmployeeID =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .Entity_ID;
    const GradeID =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .GRADE_ID || -1;
    const Year = this.state.date.selectedValue.year();
    const Month = this.state.date.selectedValue.month() + 1;
    let IsOtEligible =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .FG_OT_ELIGIBLE;
    const startDateOfEmployee =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .StartDate;
    let currentPayrollDate = moment(
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .StartDate || this.state.date.selectedValue.clone()
    );
    if (
      currentPayrollDate.month() + 1 !==
        this.state.date.selectedValue.month() + 1 ||
      currentPayrollDate.year() !== this.state.date.selectedValue.year()
    ) {
      currentPayrollDate = this.state.date.selectedValue.clone();
    }
    if (
      moment(startDateOfEmployee).month() > Month &&
      moment(startDateOfEmployee).year() >= Year
    ) {
      return notification.error({
        message: "Error",
        description: "Invalid employee !",
      });
    }
    let error = "";
    let loadedAttendanceData = [];
    await axiosInstance
      .get(
        payrollEmployee +
          `/attendance?Entity_ID=${EmployeeID}&Month=${Month}&Year=${Year}`
      )
      .then((res) => {
        if (!res.data.success) {
          error = res.data.message;
        } else {
          loadedAttendanceData = res.data.message;
        }
      })
      .catch(() => {
        error = "Error while checking employee attendance !";
      });
    if (error) {
      return notification.error({
        message: "Error",
        description: error,
      });
    }
    let Weekends = { WK1: 6, WK2: 0 };
    await axiosInstance
      .get(payrollCompany + `/weekends?Company_ID=${CompanyID}`)
      .then((res) => {
        if (res.data.success) {
          Weekends = res.data.message;
        }
      })
      .catch(() => {
        error = "Error while fetching weekend setting !";
      });
    if (error) {
      return notification.error({
        message: "Error",
        description: error,
      });
    }
    let ALFmDay = 0; //AnnualLeaveFromDay
    let ALToDay = 0; //AnnualLeaveToDay
    let ALDays = 0; //AnnualLeaveDays (total)
    let ABDays = 0; //AnnualAbsentDays (total)
    let leaveClaims = 0;
    let holidayDetails = [];
    let rosterData = [];
    await axiosInstance
      .get(
        payrollCompany +
          `/holidayTypes?Company_ID=${CompanyID}&Branch_ID=${BranchID}&Grade_ID=${GradeID}`
      )
      .then((res) => {
        if (res.data.success) {
          holidayDetails = res.data.message || [];
        }
      })
      .catch(() => {
        error = "Error while fetching holiday setting !";
      });
    if (error) {
      return notification.error({
        message: "Error",
        description: error,
      });
    }
    await axiosInstance
      .get(
        payrollEmployee +
          `/monthlyRoster?Entity_ID=${EmployeeID}&Month=${Month}&Year=${Year}`
      )
      .then((res) => {
        if (!(res.data.message || []).length) {
          error = "No roster data found for the employee !";
          return error;
        }
        if (res.data.success) {
          rosterData = res.data.message || [];
        }
      })
      .catch(() => {
        error = "Error while fetching roster data !";
      });
    if (error) {
      return notification.error({
        message: "Error",
        description: error,
      });
    }
    await axiosInstance
      .get(
        payrollEmployee +
          `/leaveClaims?Entity_ID=${EmployeeID}&TRAVEL_APPROVED_FROM=${moment(
            currentPayrollDate
          )
            .endOf("month")
            .format("YYYY-MM-DD")
            .toString()}&TRAVEL_APPROVED_TO=${moment(currentPayrollDate)
            .startOf("month")
            .format("YYYY-MM-DD")
            .toString()}`
      )
      .then((res) => {
        if (res.data.success) {
          if (res.data.message.length) {
            const data = res.data.message[0];
            if (moment(data.TRAVEL_APPROVED_FROM) < currentPayrollDate) {
              ALFmDay = 1;
              if (moment(data.TRAVEL_APPROVED_TO) < moment(data.RejoinDate)) {
                ALDays =
                  Number(data.TRAVEL_APPROVED_DAYS) -
                  Math.abs(
                    moment(data.TRAVEL_APPROVED_FROM).diff(
                      currentPayrollDate,
                      "days"
                    )
                  ) -
                  1;
                ABDays =
                  ALDays +
                  Math.abs(
                    moment(data.TRAVEL_APPROVED_TO).diff(
                      moment(data.RejoinDate),
                      "days"
                    )
                  );
              } else {
                ALDays = Math.abs(
                  moment(data.RejoinDate).diff(currentPayrollDate, "days")
                );
                ABDays = 0;
              }
              ALToDay = ALFmDay + ALDays;
            } else {
              ALFmDay = moment(data.TRAVEL_APPROVED_FROM).date();
              if (moment(data.TRAVEL_APPROVED_TO) < moment(data.RejoinDate)) {
                ALDays = Number(data.TRAVEL_APPROVED_DAYS);
                ABDays =
                  ALDays +
                  Math.abs(
                    moment(data.TRAVEL_APPROVED_TO).diff(
                      moment(data.RejoinDate),
                      "days"
                    )
                  );
              } else {
                ALDays =
                  Math.abs(
                    moment(data.TRAVEL_APPROVED_FROM).diff(
                      moment(data.RejoinDate),
                      "days"
                    )
                  ) - 1;
                ABDays = 0;
              }
              ALToDay = ALFmDay + ALDays - 1;
            }
          }
        }
      })
      .catch(() => {
        error = "Error while fetching weekend setting !";
      });
    if (error) {
      return notification.error({
        message: "Error",
        description: error,
      });
    }
    let DefaultOTHours =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .DefaultOTHours;
    let Daysstart = moment(currentPayrollDate).startOf("month").date();
    const NumberOfDaysInTheMonth = currentPayrollDate.daysInMonth();
    if (rosterData.length < NumberOfDaysInTheMonth) {
      notification.warning({
        message: "Warning",
        description:
          "Roster data for the employee is not entered for entire month !",
      });
    }
    if (Daysstart <= 0) {
      Daysstart = 1;
    }
    let state = this.state;
    let tableData = [];
    for (let DayNo = Daysstart; DayNo <= NumberOfDaysInTheMonth; DayNo++) {
      currentPayrollDate.set("D", DayNo);
      const loadedDataRow =
        loadedAttendanceData.filter(
          (lad) =>
            moment(lad.CDATE).format("YYYY-MM-DD").toString() ===
            currentPayrollDate.format("YYYY-MM-DD").toString()
        )[0] || {};
      if (loadedDataRow.POSTED) {
        state.postedStatus.selectValue = "Posted";
      } else state.postedStatus.selectValue = "Not Posted";
      const newRow = {
        key: DayNo,
        date: currentPayrollDate.format("YYYY-MM-DD").toString(),
        weekDay: currentPayrollDate.format("dddd"),
        backgroundColor:
          currentPayrollDate.weekday() + 1 === Weekends.WK1 ||
          currentPayrollDate.weekday() + 1 === Weekends.WK2
            ? "yellow"
            : undefined,
        attendance: loadedDataRow.ATT_TYPE_USER || 1,
        dutyPoint: (
          rosterData.filter(
            (rd) =>
              rd.DutyDate.split("T")[0] ===
              currentPayrollDate.format("YYYY-MM-DD").toString()
          )[0] || {}
        ).DutyPointName,
        payType:
          { 0: "PAID", 1: "UNPAID", 2: "HALF PAID" }[loadedDataRow.DAY_TYPE] ||
          "PAID",
        WorkHrs1:
          loadedDataRow.WORK_HRS || this.state.payrollSettingData.REG_HRS * 1,
        days: 1,
        normalOT: loadedDataRow.OT_HRS || DefaultOTHours,
        IsOtEligible,
        spOT: loadedDataRow.SP_OT_HRS || 0,
        wotHrs: loadedDataRow.WEEKEND_OT_HRS || 0,
        hotOT: loadedDataRow.HOL_OT_HRS || 0,
        deductionHrs: loadedDataRow.deduction_Hrs || 0,
        NORMAL_OT_HRS:
          this.state.employeeData.list[this.state.employeeData.selectedIndex]
            .NORMAL_OT_HRS || 0,
        SP_OT_HRS:
          this.state.employeeData.list[this.state.employeeData.selectedIndex]
            .SP_OT_HRS || 0,
        WEEKEND_OT_HRS:
          this.state.employeeData.list[this.state.employeeData.selectedIndex]
            .WEEKEND_OT_HRS || 0,
        HOLIDAY_OT_HRS:
          this.state.employeeData.list[this.state.employeeData.selectedIndex]
            .HOLIDAY_OT_HRS || 0,
      };
      if (!loadedDataRow.EMPID) {
        // load if no data existed in the table
        if (DayNo >= ALFmDay && DayNo <= ALToDay) {
          newRow.attendance = 7;
          newRow.payType = "UNPAID";
          newRow.WorkHrs1 = this.state.payrollSettingData.REG_HRS * 0;
          newRow.days = 0;
        } else if (DayNo > ALToDay && DayNo <= ABDays) {
          newRow.attendance = 3;
          newRow.payType = "UNPAID";
          newRow.WorkHrs1 = this.state.payrollSettingData.REG_HRS * 0;
          newRow.days = 0;
        } else {
        }
        if (holidayDetails.length) {
          for (let hd of holidayDetails) {
            if (
              moment(hd.Holiday_Date).format("YYYY-MM-DD") ===
              currentPayrollDate.format("YYYY-MM-DD")
            ) {
              newRow.backgroundColor = "blue";
              if (hd.Holiday_DayType) {
                newRow.attendance = hd.Holiday_DayType;
                newRow.payType = "PAID";
                newRow.days = 1;
              }
            }
          }
        }
      }
      tableData.push(newRow);
    }
    state.tableData.list = tableData;
    this.setState(state);
  };

  saveAttendance = async () => {
    if (!this.state.companyData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select a company !",
      });
    }
    if (!this.state.branchData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select a branch !",
      });
    }
    if (!this.state.date.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select date (month-year) !",
      });
    }
    if (!this.state.employeeData.selectedValue) {
      return notification.error({
        message: "Error",
        description: "Please select an employee !",
      });
    }
    const CompanyID =
      this.state.companyData.list[this.state.companyData.selectedIndex]
        .Company_ID;
    const BranchID =
      this.state.branchData.list[this.state.branchData.selectedIndex].Branch_ID;
    const EmployeeID =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .Entity_ID;
    const GradeID =
      this.state.employeeData.list[this.state.employeeData.selectedIndex]
        .GRADE_ID || -1;
    const Year = this.state.date.selectedValue.year();
    const Month = this.state.date.selectedValue.month() + 1;
    await axiosInstance
      .post(payrollEmployee + "/attendance", {
        CompanyID: CompanyID,
        BranchID: BranchID,
        EmployeeID: EmployeeID,
        GradeID: GradeID,
        Year: Year,
        Month: Month,
        data: this.state.tableData.list,
      })
      .then((res) => {
        if (!res.data.success) {
          return notification.error({
            message: "Error",
            description: res.data.message,
          });
        }
        notification.success({ message: "Success" });
      })
      .catch((error) => {
        notification.error({ message: "Error", description: error });
      });
  };

  onChange = (value) => {
    if (!value) return;
    let state = this.state;
    let theIndex = value.split("+-")[1];
    let theValue = value.split("+-")[2];
    switch (value.split("+-")[0]) {
      case "company":
        // set company data and reset other
        this.setState(
          {
            companyData: {
              list: state.companyData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
          },
          () => {
            state = this.state;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  payrollBranch +
                    "?Company_ID=" +
                    state.companyData.list[theIndex].Company_ID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      branchData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    branchData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
          }
        );
        break;
      case "branch":
        this.setState(
          {
            branchData: {
              list: state.branchData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
          },
          () => {
            state = this.state;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  payrollEmployee +
                    "?Company_ID=" +
                    state.companyData.list[theIndex].Company_ID +
                    "&Branch_ID=" +
                    state.branchData.list[theIndex].Branch_ID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      employeeData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    employeeData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
          }
        );
        break;
      case "employee":
        this.setState({
          employeeData: {
            list: state.employeeData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
        });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this._isMounted = true;
    this.controller = new AbortController();
    this.getInitialState().then((st) => {
      if (this._isMounted) this.setState(st);
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.controller.abort();
  }

  render() {
    return (
      <div style={{ margin: 20 }}>
        <Row>
          <Col span={24}>
            <Card style={{ width: "100%" }}>
              <Row>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 6 }}
                  md={{ span: 3 }}
                  lg={{ span: 2 }}
                >
                  Company
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 18 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  style={{ marginBottom: 20 }}
                >
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a company"
                    optionFilterProp="children"
                    onChange={(val) => this.onChange(val || "company+-")}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={
                      this.state.companyData.selectedValue
                        ? "company+-" +
                          this.state.companyData.selectedIndex +
                          "+-" +
                          this.state.companyData.selectedValue
                        : null
                    }
                  >
                    {this.state.companyData.list.map((company, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={
                            "company+-" + index + "+-" + company.Company_Name
                          }
                        >
                          {company.Company_Name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col
                  xs={{ span: 0 }}
                  sm={{ span: 0 }}
                  md={{ span: 1 }}
                  lg={{ span: 1 }}
                ></Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 6 }}
                  md={{ span: 3 }}
                  lg={{ span: 2 }}
                >
                  Branch
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 18 }}
                  md={{ span: 9 }}
                  lg={{ span: 4 }}
                  style={{ marginBottom: 20 }}
                >
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a branch"
                    optionFilterProp="children"
                    onChange={(val) => this.onChange(val || "branch+-")}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={
                      this.state.branchData.selectedValue
                        ? "branch+-" +
                          this.state.branchData.selectedIndex +
                          "+-" +
                          this.state.branchData.selectedValue
                        : null
                    }
                  >
                    {this.state.branchData.list.map((branch, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={"branch+-" + index + "+-" + branch.Branch_Name}
                        >
                          {branch.Branch_Name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 1 }}
                ></Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 6 }}
                  md={{ span: 3 }}
                  lg={{ span: 2 }}
                >
                  Month/Year
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 18 }}
                  md={{ span: 8 }}
                  lg={{ span: 4 }}
                  style={{ marginBottom: 20 }}
                >
                  <DatePicker
                    picker="month"
                    style={{ width: "100%" }}
                    format={"YYYY-MMM"}
                    value={this.state.date.selectedValue}
                    onChange={(date) => {
                      this.setState({ date: { selectedValue: date } });
                    }}
                  />
                </Col>
                <Col
                  xs={{ span: 0 }}
                  sm={{ span: 0 }}
                  md={{ span: 1 }}
                  lg={{ span: 0 }}
                ></Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 6 }}
                  md={{ span: 3 }}
                  lg={{ span: 2 }}
                >
                  Employee
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 18 }}
                  md={{ span: 9 }}
                  lg={{ span: 8 }}
                >
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select an employee"
                    optionFilterProp="children"
                    onChange={(val) => this.onChange(val || "employee+-")}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={
                      this.state.employeeData.selectedValue
                        ? "employee+-" +
                          this.state.employeeData.selectedIndex +
                          "+-" +
                          this.state.employeeData.selectedValue
                        : null
                    }
                  >
                    {this.state.employeeData.list.map((employee, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={"employee+-" + index + "+-" + employee.Name}
                        >
                          {employee.Name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                  style={{ marginBottom: 20 }}
                ></Col>
                <Col
                  xs={{ span: 0 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 1 }}
                ></Col>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 10 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                >
                  <span style={{ fontWeight: "bold" }}>Status: </span>
                  <span>{this.state.postedStatus.selectValue}</span>
                </Col>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 7 }}
                  lg={{ span: 4 }}
                >
                  <Button
                    style={{ width: "100%" }}
                    onClick={this.loadAttendance}
                  >
                    Load
                  </Button>
                </Col>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                ></Col>
                <Col
                  xs={{ span: 0 }}
                  sm={{ span: 1 }}
                  md={{ span: 1 }}
                  lg={{ span: 1 }}
                ></Col>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 4 }}
                  lg={{ span: 2 }}
                >
                  <Button
                    style={{ width: "100%" }}
                    onClick={this.saveAttendance}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24}>
            <Table
              pagination={false}
              columns={[
                {
                  title: "Date",
                  width: 100,
                  dataIndex: "date",
                  key: "date",
                  fixed: "left",
                  align: "center",
                  render: (text, item) => {
                    return {
                      props: {
                        style: {
                          background: item.backgroundColor,
                        },
                      },
                      children: text,
                    };
                  },
                },
                {
                  title: "Week Day",
                  width: 100,
                  dataIndex: "weekDay",
                  key: "weekDay",
                  align: "center",
                  render: (text, item) => {
                    return {
                      props: {
                        style: {
                          background: item.backgroundColor,
                        },
                      },
                      children: text,
                    };
                  },
                },
                {
                  title: "Attendance",
                  width: 100,
                  dataIndex: "attendance",
                  key: "attendance",
                  align: "center",
                  render: (text, item) => {
                    return {
                      props: {
                        style: {
                          background: item.backgroundColor,
                        },
                      },
                      children: (
                        <Select
                          bordered={false}
                          value={text ? Number(text) : undefined}
                          onChange={(value) => {
                            let tableData = [];
                            for (let row of this.state.tableData.list) {
                              let rowData = { ...row };
                              if (row.key === item.key) {
                                rowData.attendance = value;
                                if (
                                  // AnnualLeave, Absent, CasualLeave, LeaveWithoutPay
                                  [7, 3, 9, 20].includes(Number(value))
                                ) {
                                  rowData.payType = "UNPAID";
                                  row.WorkHrs1 =
                                    this.state.payrollSettingData.REG_HRS * 0;
                                  rowData.days =
                                    this.state.payrollSettingData.REG_HRS * 0;
                                } else if (
                                  // FirstHalf, SecondHalf
                                  [5, 6].includes(Number(value))
                                ) {
                                  rowData.payType = "HALF PAID";
                                  row.WorkHrs1 =
                                    this.state.payrollSettingData.REG_HRS * 0.5;
                                  rowData.days =
                                    this.state.payrollSettingData.REG_HRS * 0.5;
                                } else {
                                  rowData.payType = "PAID";
                                  row.WorkHrs1 =
                                    this.state.payrollSettingData.REG_HRS * 1;
                                  rowData.days =
                                    this.state.payrollSettingData.REG_HRS * 1;
                                }
                              }
                              tableData.push(rowData);
                            }
                            this.setState({
                              tableData: {
                                ...this.state.tableData,
                                list: tableData,
                              },
                            });
                          }}
                        >
                          {this.state.attendanceTypesData.list.map((type) => {
                            return (
                              <Select.Option key={type.ATID} value={type.ATID}>
                                {type.AttType}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      ),
                    };
                  },
                },
                {
                  title: "Duty Point",
                  width: 100,
                  dataIndex: "dutyPoint",
                  key: "dutyPoint",
                  align: "center",
                },
                // {
                //   title: "Pay Type",
                //   width: 100,
                //   dataIndex: "payType",
                //   key: "payType",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: text,
                //     };
                //   },
                // },
                // {
                //   title: "Days",
                //   width: 100,
                //   dataIndex: "days",
                //   key: "days",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: text,
                //     };
                //   },
                // },
                // {
                //   title: "NOT Hrs.",
                //   width: 100,
                //   dataIndex: "normalOT",
                //   key: "normalOT",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: (
                //         <InputNumber
                //           value={text}
                //           disabled={!item.IsOtEligible}
                //           onChange={(value) => {
                //             let tableData = [];
                //             for (let row of this.state.tableData.list) {
                //               let rowData = { ...row };
                //               if (row.key === item.key) {
                //                 rowData.normalOT = value;
                //               }
                //               tableData.push(rowData);
                //             }
                //             this.setState({
                //               tableData: {
                //                 ...this.state.tableData,
                //                 list: tableData,
                //               },
                //             });
                //           }}
                //         />
                //       ),
                //     };
                //   },
                // },
                // {
                //   title: "Sp. OT Hrs.",
                //   width: 100,
                //   dataIndex: "spOT",
                //   key: "spOT",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: (
                //         <InputNumber
                //           value={text}
                //           disabled={!item.IsOtEligible}
                //           onChange={(value) => {
                //             let tableData = [];
                //             for (let row of this.state.tableData.list) {
                //               let rowData = { ...row };
                //               if (row.key === item.key) {
                //                 rowData.spOT = value;
                //               }
                //               tableData.push(rowData);
                //             }
                //             this.setState({
                //               tableData: {
                //                 ...this.state.tableData,
                //                 list: tableData,
                //               },
                //             });
                //           }}
                //         />
                //       ),
                //     };
                //   },
                // },
                // {
                //   title: "WOT Hrs.",
                //   width: 100,
                //   dataIndex: "wotHrs",
                //   key: "wotHrs",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: (
                //         <InputNumber
                //           value={text}
                //           disabled={!item.IsOtEligible}
                //           onChange={(value) => {
                //             let tableData = [];
                //             for (let row of this.state.tableData.list) {
                //               let rowData = { ...row };
                //               if (row.key === item.key) {
                //                 rowData.wotHrs = value;
                //               }
                //               tableData.push(rowData);
                //             }
                //             this.setState({
                //               tableData: {
                //                 ...this.state.tableData,
                //                 list: tableData,
                //               },
                //             });
                //           }}
                //         />
                //       ),
                //     };
                //   },
                // },
                // {
                //   title: "HOT Hrs.",
                //   width: 100,
                //   dataIndex: "hotOT",
                //   key: "hotOT",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: (
                //         <InputNumber
                //           value={text}
                //           disabled={!item.IsOtEligible}
                //           onChange={(value) => {
                //             let tableData = [];
                //             for (let row of this.state.tableData.list) {
                //               let rowData = { ...row };
                //               if (row.key === item.key) {
                //                 rowData.hotOT = value;
                //               }
                //               tableData.push(rowData);
                //             }
                //             this.setState({
                //               tableData: {
                //                 ...this.state.tableData,
                //                 list: tableData,
                //               },
                //             });
                //           }}
                //         />
                //       ),
                //     };
                //   },
                // },
                // {
                //   title: "Deduction Hrs.",
                //   width: 100,
                //   dataIndex: "deductionHrs",
                //   key: "deductionHrs",
                //   align: "center",
                //   render: (text, item) => {
                //     return {
                //       props: {
                //         style: {
                //           background: item.backgroundColor,
                //         },
                //       },
                //       children: (
                //         <InputNumber
                //           value={text}
                //           onChange={(value) => {
                //             let tableData = [];
                //             for (let row of this.state.tableData.list) {
                //               let rowData = { ...row };
                //               if (row.key === item.key) {
                //                 rowData.deductionHrs = value;
                //               }
                //               tableData.push(rowData);
                //             }
                //             this.setState({
                //               tableData: {
                //                 ...this.state.tableData,
                //                 list: tableData,
                //               },
                //             });
                //           }}
                //         />
                //       ),
                //     };
                //   },
                // },
                {
                  title: "Remarks",
                  width: 100,
                  dataIndex: "remarks",
                  key: "remarks",
                  align: "center",
                  render: (text, item) => {
                    return {
                      props: {
                        style: {
                          background: item.backgroundColor,
                        },
                      },
                      children: (
                        <Input.TextArea
                          value={text}
                          rows={1}
                          onChange={(e) => {
                            let tableData = [];
                            for (let row of this.state.tableData.list) {
                              let rowData = { ...row };
                              if (row.key === item.key) {
                                rowData.remarks = e.target.value;
                              }
                              tableData.push(rowData);
                            }
                            this.setState({
                              tableData: {
                                ...this.state.tableData,
                                list: tableData,
                              },
                            });
                          }}
                        />
                      ),
                    };
                  },
                },
              ]}
              dataSource={this.state.tableData.list}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(EmployeeAttendance);
